import { useTranslation } from 'react-i18next';

import { GetParticipantDataQuery as GetParticipantData } from '__generated__/graphql';

import { assetUrl, encodeUrl } from '../../../../common/helpers';
import RegistrationSummary from './RegistrationSummary';
import UI from '../../../../common/UI';
import useUrlState from '../../../../common/useUrlState';

type Participant = GetParticipantData['project']['participant'];

export interface RegistrationSummaryListProps {
  participant: Participant;
}

const RegistrationSummaryList = ({
  participant,
}: RegistrationSummaryListProps) => {
  const { t } = useTranslation();

  const registrationSummaries = participant.registration_summaries;

  const [urlState] = useUrlState({
    parse: (params, { string }) => ({
      event: string(params.event),
    }),
  });

  return (
    <UI.GridContainer>
      <UI.SectionHeading>
        {t('registrations')}
      </UI.SectionHeading>

      {registrationSummaries.length > 0 && (
        <UI.GridContainer sc={{ gutter: 0.5 }}>
          {registrationSummaries.map((registrationSummary) => {
            const open = registrationSummary.event.id === urlState.event;
            const to = `?${encodeUrl({ event: !open ? registrationSummary.event.id : null })}`;
            const muted = !open && !!urlState.event;

            return (
              <RegistrationSummary
                to={to}
                open={open}
                muted={muted}
                registrationSummary={registrationSummary}
                participantId={participant.id}
                key={registrationSummary.event.id}
              />
            );
          })}
        </UI.GridContainer>
      )}

      {registrationSummaries.length === 0 && (
        <UI.Card sc={{ padding: 6, textAlign: 'center' }}>
          <img src={assetUrl('images/ticket.svg')} alt="" height={120} />
          <UI.Div>{t('no_registrations_for_participant')}</UI.Div>
        </UI.Card>
      )}
    </UI.GridContainer>
  );
};

export default RegistrationSummaryList;
